export default "__VITE_ASSET__XncC$OUd__"